export enum CategoryAdditionalMarketingDataTargetEnum {
  In_same_window = 'sameWindow',
  In_new_window = 'newWindow'
}
